import React from "react";
import { List, CreateButton } from "@refinedev/mui";
import { DataGrid } from "@shared/components/DataGrid";

import { CsvExportButton } from "@shared/components";
import { useNavigate } from "react-router";

import { useProductsList } from "./controller";
import { useProductsListColumns } from "./columns";
import { useQueryClient } from "@tanstack/react-query";

export const ProductList = React.memo(() => {
  const {
    rows,
    loading,
    selectedRows,
    dataToExport,
    setSelectedRows,
    refetch,
    translate,
    tableProps,
  } = useProductsList();

  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const handleRefetch = React.useCallback(() => {
    queryClient.invalidateQueries({ queryKey: ["products"], refetchType: "all" });
    refetch();
  }, [queryClient, refetch]);

  const columns = useProductsListColumns(handleRefetch, translate, (row) => navigate(`/products/edit/${row.id}`, { state: { product: row } }));

  return (
    <>
      <List
        title="Produtos"
        headerButtons={
          <>
            <CsvExportButton
              data={dataToExport}
              filename="produtos.csv"
              isDisabled={loading || !rows}
            />
            
            <CreateButton onClick={() => navigate("/products/create")} />
          </>
        }
      >
        <DataGrid
          {...tableProps}
          rows={rows}
          loading={loading}
          columns={columns} 
          checkboxSelection
          rowSelectionModel={selectedRows}
          onRowSelectionModelChange={(selectionModel) =>
            setSelectedRows(selectionModel as number[])
          }
        />
      </List>
    </>
  );
});
